import _extends from '@babel/runtime/helpers/esm/extends';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useContext, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FocusGridContext } from '@elliemae/ds-shared/FocusGroup/FocusGrid';
import { evaluateTransforms, evaluateFormatters } from '@elliemae/ds-shared/createDataInstance/utils';
import DSTruncatedTooltipText from '@elliemae/ds-basic/TruncatedTooltipText';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BodyCell(_ref) {
  var Component = _ref.component,
      classProps = _ref.classProps,
      rowProps = _ref.rowProps,
      column = _ref.column,
      columnIndex = _ref.columnIndex,
      rowIndex = _ref.rowIndex,
      grid = _ref.grid;

  var rowData = rowProps.rowData,
      rowKey = rowProps.rowKey,
      isScrolling = rowProps.isScrolling,
      extraRowProps = _objectWithoutProperties(rowProps, ["rowData", "rowKey", "isScrolling"]);

  var property = column.property,
      cell = column.cell,
      props = column.props;
  var evaluatedProperty = property || cell && cell.property;
  var ref = useRef(null);

  var _useContext = useContext(FocusGridContext),
      register = _useContext.register;

  var registerFocus = useCallback(function (node) {
    register(node, rowIndex, columnIndex);
  }, []);
  useEffect(function () {
    registerFocus(ref.current);
  }, [ref.current]);

  var _ref2 = cell || {},
      _ref2$transforms = _ref2.transforms,
      transforms = _ref2$transforms === void 0 ? [] : _ref2$transforms,
      _ref2$formatters = _ref2.formatters,
      formatters = _ref2$formatters === void 0 ? [] : _ref2$formatters,
      _ref2$fixedFormatters = _ref2.fixedFormatters,
      fixedFormatters = _ref2$fixedFormatters === void 0 ? [] : _ref2$fixedFormatters,
      _ref2$scrollingFormat = _ref2.scrollingFormatters,
      scrollingFormatters = _ref2$scrollingFormat === void 0 ? [] : _ref2$scrollingFormat;

  var extraParameters = _objectSpread({
    columnIndex: columnIndex,
    property: evaluatedProperty,
    column: column,
    rowData: rowData,
    rowIndex: rowIndex,
    rowKey: rowKey,
    isScrolling: isScrolling,
    // improve performance on scroll rendering a lightweight component instead
    registerFocus: registerFocus
  }, extraRowProps);

  var withTooltip = function withTooltip(v) {
    return classProps && classProps.wrapText ? v : /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
      value: v
    });
  };

  var value = rowData["_".concat(evaluatedProperty)] || rowData[evaluatedProperty];
  var transformed = evaluateTransforms(transforms, value, extraParameters);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    "data-testid": "column-".concat(property),
    tabIndex: -1,
    classProps: classProps
  }, props, cell && cell.props, transformed), transformed.children || evaluateFormatters(!isScrolling ? [withTooltip].concat(_toConsumableArray(formatters), _toConsumableArray(fixedFormatters)) : [].concat(_toConsumableArray(scrollingFormatters), _toConsumableArray(fixedFormatters)), value, extraParameters, grid));
}

BodyCell.propTypes = {
  component: PropTypes.element,
  classProps: PropTypes.shape({
    wrapText: PropTypes.bool
  }),
  rowProps: PropTypes.shape({
    rowData: PropTypes.shape({}),
    rowKey: PropTypes.string,
    isScrolling: PropTypes.bool
  }),
  column: PropTypes.shape({
    property: PropTypes.string,
    cell: PropTypes.any,
    props: PropTypes.shape({})
  }),
  columnIndex: PropTypes.number,
  rowIndex: PropTypes.number,
  grid: PropTypes.any
};

export default BodyCell;
//# sourceMappingURL=BodyCell.js.map
